type CallbackFunction<T> = (data: T) => void
export class EventEmitter<T> {
  private listeners: { [event: string]: CallbackFunction<T>[] } = {}

  subscribe(event: string, callback: CallbackFunction<T>): void {
    if (!this.listeners[event]) {
      this.listeners[event] = []
    }
    this.listeners[event].push(callback)
  }

  publish(event: string, data: T): void {
    if (this.listeners[event]) {
      this.listeners[event].forEach((callback) => {
        callback(data)
      })
    }
  }
}
